import { reportSalesByNoteTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SALES_BY_NOTE_FILTERS,
  RESTORE_INITIAL
} = reportSalesByNoteTypes;

const initialState = {
  data: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSalesByNoteReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case SET_SALES_BY_NOTE_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
